module.exports = __webpack_public_path__ + "static/media/2.6820d4e1.jpg";